import { createAction } from '../utils';
import { AsyncType } from './constants';
export var asyncStart = createAction(AsyncType.START);
export var asyncSuccess = createAction(AsyncType.SUCCESS);
export var asyncError = createAction(AsyncType.ERROR);
export var asyncInitial = createAction(AsyncType.INITIAL);
export var createAsyncActions = function (key) { return ({
    start: function (idx) { return asyncStart({ key: key, idx: idx }); },
    success: function (data, meta, idx) { return asyncSuccess({
        key: key,
        idx: idx,
        data: data,
        meta: meta,
    }); },
    error: function (error, idx) { return asyncError({ key: key, idx: idx, error: error }); },
    reset: function (idx) { return asyncInitial({ key: key, idx: idx }); },
}); };
